export interface WebComponentConfig {
  port?: number;
  scriptSrc: string;
  useLocalServer?: boolean;
  apiUrlItg?: string;
  apiUrlStg?: string;
  apiUrlSbx?: string;
  apiUrlProd?: string;
  customConfig?: Record<string, string | number | boolean>;
}

export enum WEB_COMPONENTS {
  IDA = 'ida',
}
